// @ts-check
import AnimateHeight from "react-animate-height";
import React from "react";

/**
 * @component
 * @param {object} props
 * @param {boolean} props.visible visible or not
 * @param {number} [props.delayIn] seconds to delay animating in
 * @param {number} [props.delayOut] seconds to delay animating in
 * @param {number} [props.delay] seconds to delay animating in
 * @param {boolean} [props.fade] should the content fade while animating height
 * @param {React.ReactNode} props.children React children
 *
 */
function SlideVerticalAnimation(props) {
    const height = props.visible ? "auto" : 0;
    const delay =
        props.visible && props.delayIn
            ? props.delayIn
            : !props.visible && props.delayOut
            ? props.delayOut
            : props.delay || 0;

    return (
        <AnimateHeight duration={250} height={height} delay={delay} animateOpacity={props.fade}>
            {props.children}
        </AnimateHeight>
    );
}

export default SlideVerticalAnimation;
